import { AutogenModelGeographicCity, AutogenRowGeographicCity } from "./autogen/AutogenModelGeographicCity";

export class ModelGeographicCity extends AutogenModelGeographicCity<RowGeographicCity> {
	constructor() {
		super(RowGeographicCity);
	}
}

export class RowGeographicCity extends AutogenRowGeographicCity {
}